<modal-form-container title="New organization" [showModal]="true" (closeModalEvent)="close()">
  <form class="gf" [formGroup]="organizationForm" (ngSubmit)="handleSubmit()" novalidate>
    <p class="gf__lead">Group the contacts who work at one company. You can add contacts once it is created.</p>

    <div class="gf__grid">
      <input-field
        class="gf__wide"
        label="Name"
        [errorMessage]="submitted && organizationForm.controls.name.invalid ? 'Enter the organization’s name' : ''"
      >
        <input class="input-style" formControlName="name" autocomplete="organization" />
      </input-field>

      <input-field class="gf__wide" label="Description" hint="Optional. Who they are, or why you message them.">
        <textarea class="input-style" formControlName="description" rows="3"></textarea>
      </input-field>

      <input-field
        label="Country"
        [errorMessage]="submitted && organizationForm.controls.country.invalid ? 'Choose a country' : ''"
      >
        <select name="country" class="input-style" formControlName="country">
          <option value="" disabled>Choose a country</option>
          @for (country of countries; track country) {
            <option [value]="country">{{ country }}</option>
          }
        </select>
      </input-field>

      <input-field
        label="Region or state"
        [errorMessage]="submitted && organizationForm.controls.region.invalid ? 'Enter a region or state' : ''"
      >
        <input class="input-style" formControlName="region" autocomplete="address-level1" />
      </input-field>

      <input-field
        label="City"
        [errorMessage]="submitted && organizationForm.controls.city.invalid ? 'Enter a city' : ''"
      >
        <input class="input-style" formControlName="city" autocomplete="address-level2" />
      </input-field>

      <input-field
        label="Industry"
        [errorMessage]="submitted && organizationForm.controls.industry.invalid ? 'Choose an industry' : ''"
      >
        <select name="industry" class="input-style" formControlName="industry">
          <option value="" disabled>Choose an industry</option>
          @for (industry of industries; track industry.value) {
            <option [value]="industry.value">{{ industry.label }}</option>
          }
        </select>
      </input-field>
    </div>

    @if (saveError) {
      <p class="gf__error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        {{ saveError }}
      </p>
    }

    <div class="gf__foot">
      <customizable-button title="Cancel" (click)="close()" type="button" [outline]="true" />
      <customizable-button title="Create organization" type="submit" [loading]="contactServiceLoading" />
    </div>
  </form>
</modal-form-container>
